export const MINIMUM_SARCASM_SCORE_INPUT_NAME = 'minimumSarcasmScoreName';
export const MAXIMUM_SARCASM_SCORE_INPUT_NAME = 'maximumSarcasmScoreName';

export const VALUES_OUT_OF_RANGE_ERROR = '*Please input scores from 0 to 100 (inclusive)';
export const MAXIMUM_LESS_THAN_MINIMUM_ERROR = '*Please input a maximum score greater than the minimum score';
export const INVALID_RANGE_ERROR = '*Please input a valid score range';


// WEBPACK FOOTER //
// ./src/features/shared-components/SarcasmScoreRangeFilter/constants.js